/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterError,
  PresenterOneMonthlyClosingSettingResponse,
  PresenterResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class MonthlyClosingSettings<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Get next setting of a monthly closing setting
   *
   * @tags monthly_closing_settings
   * @name GetMonthlyClosingSettingsByIdNext
   * @summary Get next setting of a monthly closing setting
   * @request GET:/monthly_closing_settings/{id}/next
   */
  getMonthlyClosingSettingsByIdNext = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneMonthlyClosingSettingResponse;
      },
      PresenterError
    >({
      path: `/monthly_closing_settings/${id}/next`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
